/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum ProgrammingLanguages {
  CSharp = 0,
  Php = 1,
  Java = 2,
  JavaScript = 3,
  Python = 4,
  Curl = 5
}
